<template>
  <v-container id="user-profile" fluid tag="section">
    <v-row justify="center">
      <v-col cols="12" md="8">
        <base-material-card color="#ac8a2e" inline title="Legales">
          <template v-slot:after-heading>
            <div class="font-weight-light card-title mt-2">
              {{ tittle }}
            </div>
          </template>
          <validation-observer v-slot="{ handleSubmit }">
            <form @submit.prevent="handleSubmit(validateForm)">
              <v-container class="py-0">
                <v-row>
                  <v-row>
                    <v-col cols="6">
                      <v-menu ref="menu" v-model="menu" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                        <template v-slot:activator="{ on }">
                          <validation-provider v-slot="{ errors }" name="fecha" rules="required">
                            <v-text-field v-model="dataForm.fecha" color="gold" :error-messages="errors" label="Fecha" readonly v-on="on" />
                          </validation-provider>
                        </template>
                        <v-date-picker
                          v-model="dataForm.fecha"
                          color="gold"
                          landscape
                          scrollable
                          locale="es-419"
                          no-title
                          @input="menu = false"
                        />
                      </v-menu>
                    </v-col>
                    <v-col cols="6">
                      <base-upload-files folder="/documentaciones/legales" :documento-id="dataForm.documento_id" tipo="pdf" @documento="dataForm.documento_id = $event" />
                    </v-col>
                    <v-col cols="6">
                      <validation-provider v-slot="{ errors }" name="contraparte" rules="required">
                        <v-select v-model="dataForm.contraparte" color="gold" :error-messages="errors" label="Contraparte" :items="contrapartes" clearable>
                          <template v-slot:item="{ attrs, item, on }">
                            <v-list-item v-bind="attrs" active-class="gold elevation-4 white--text" class="mx-3 mb-3 v-sheet" elevation="0" v-on="on">
                              <v-list-item-content>
                                <v-list-item-title v-text="item" />
                              </v-list-item-content>
                            </v-list-item>
                          </template>
                        </v-select>
                      </validation-provider>
                    </v-col>
                    <v-col cols="6">
                      <template v-if="dataForm.contraparte == 'Empleado/Jugador'">
                        <validation-provider v-slot="{ errors }" name="contraparte" rules="required">
                          <v-autocomplete v-model="dataForm.contraparte_user_id" :error-messages="errors" :items="empleadosJugadores" item-value="user_id" item-text="fullName" :label="'Empleado/Jugador'" color="gold" clearable>
                            <template v-slot:item="{ attrs, item, on }">
                              <v-list-item v-bind="attrs" active-class="gold elevation-4 white--text" class="mx-3 mb-3 v-sheet" elevation="0" v-on="on">
                                <v-list-item-content>
                                  <v-list-item-title v-text="item.fullName" />
                                </v-list-item-content>
                              </v-list-item>
                            </template>
                          </v-autocomplete>
                        </validation-provider>
                      </template>
                      <template v-else-if="dataForm.contraparte == 'Club'">
                        <validation-provider v-slot="{ errors }" name="contraparte" rules="required">
                          <v-autocomplete
                            v-model="dataForm.club_id"
                            :error-messages="errors"
                            :items="clubes"
                            item-value="id"
                            item-text="descripcion"
                            :label="'Club'"
                            color="gold"
                            clearable
                          >
                            <template v-slot:item="{ attrs, item, on }">
                              <v-list-item v-bind="attrs" active-class="gold elevation-4 white--text" class="mx-3 mb-3 v-sheet" elevation="0" v-on="on">
                                <v-list-item-content>
                                  <v-list-item-title v-text="item.descripcion" />
                                </v-list-item-content>
                              </v-list-item>
                            </template>
                          </v-autocomplete>
                        </validation-provider>
                      </template>
                      <template v-if="dataForm.contraparte == 'Otro'">
                        <validation-provider v-slot="{ errors }" name="contraparte" rules="required|max:191">
                          <v-text-field
                            v-model="dataForm.contraparte_otro"
                            color="#ac8a2e"
                            :error-messages="errors"
                            label="Otros"
                          />
                        </validation-provider>
                      </template>
                    </v-col>
                    <v-col cols="6">
                      <v-text-field v-model="dataForm.contraparte_contacto" color="#ac8a2e" label="Contacto" />
                    </v-col>
                    <v-spacer />
                    <v-col cols="12">
                      <validation-provider
                        v-slot="{ errors }"
                        name="detalle"
                        rules="required|max:191"
                      >
                        <v-textarea
                          v-model="dataForm.detalle"
                          color="#ac8a2e"
                          :error-messages="errors"
                          name="input-6-1"
                          label="Detalle"
                        />
                      </validation-provider>
                    </v-col>
                    <v-col cols="3">
                      <v-checkbox v-model="dataForm.propio_sn" label="Litigio propio." />
                    </v-col>
                  </v-row>
                  <v-col cols="12">
                    <v-row justify="space-between">
                      <v-btn v-if="mode !=='show'" :disabled="$disabled()" color="#ac8a2e" class="mr-0" type="submit">
                        Guardar
                      </v-btn>
                    </v-row>
                  </v-col>
                </v-row>
              </v-container>
            </form>
          </validation-observer>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    props: {
      mode: {
        type: String,
        required: true,
      },
      id: {
        type: Number,
        required: false,
        default: 0,
      },
    },

    data: () => ({
      tittle: 'Nuevo',
      menu: false,
      dataForm: {
        propio_sn: false,
        contraparte_user_id: '',
        club_id: '',
        contraparte_otro: '',
        contraparte_contacto: '',
        detalle: '',
        documento_id: null,
        contraparte: '',
      },
      clubes: [],
      staff: [],
      jugadores: [],
      empleadosJugadores: [],
      contrapartes: ['Empleado/Jugador', 'Club', 'Otro'],
    }),
    computed: {

    },
    watch: {
      newFile (val) {
        this.dataForm.documento_id = this.newFile.id
      },
    },

    created () {
      this.setTittle()
      this.getClubes()
      this.getStaff()
      this.getJugadores()
      if (this.mode === 'edit') {
        this.getLitigio()
      }
    },

    methods: {
      setTittle: function () {
        if (this.mode === 'new') {
          this.tittle = 'Nuevo litigio'
        } else {
          this.tittle = 'Editar litigio'
        }
      },

      getClubes: function () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/club_get' }).then(response => { this.clubes = response })
      },

      getStaff: function () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/staff_get' }).then(response => { this.staff = response })
      },

      getJugadores: function () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/jugador' }).then(response => {
          this.jugadores = response
          this.empleadosJugadores = this.empleadosJugadores.concat(this.staff)
          this.empleadosJugadores = this.empleadosJugadores.concat(this.jugadores)
        })
      },

      getLitigio: function () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/litigios_get/' + this.id }).then(response => { this.dataForm = response })
      },

      validateForm (scope) {
        this.saveLitigio()
      },

      saveLitigio: async function () {
        const mode = this.mode === 'new' ? 'postData' : 'putData'
        await this.$store.dispatch('axiosMod/' + mode, { url: '/api/litigios_agregar', dataForm: this.dataForm }).then(response => {
          this.$store.commit('toast/show', { tipo: 'success', messages: ['Alta de litigio exitosa'] })
          this.$router.push({ name: 'Legales' }).catch(error => {
            if (error.response.data.errors) {
              this.$store.commit('toast/show', { tipo: 'error', messages: [error.response.data.errors] })
            } else if (error.response.data) {
              this.$store.commit('toast/show', { tipo: 'error', messages: [error.response.data] })
            } else {
              this.$store.commit('toast/show', { tipo: 'error', messages: ['Ocurrio un error en el servidor'] })
            }
          })
        })
        /* const method = (this.mode === 'new') ? 'post' : 'put'
        await this.$http({
          method: method,
          url: '/api/litigios_agregar',
          data: {
            ...this.dataForm,
          },
        }).then(response => {
          this.$store.commit('toast/show', { tipo: 'success', messages: ['Alta de litigio exitosa'] })
          this.$router.push({ name: 'Legales' })
        }).catch(error => {
          this.$store.commit('toast/show', { tipo: 'error', messages: error.response.data.errors })
        }) */
      },
    },
  }
</script>
